import React, { useState, useEffect, useCallback } from "react";
import { Grid, IconButton, Box } from "@mui/material";
import { Add } from "@mui/icons-material";
import ArticleCard from "./ArticleCard.js";
import { default as EventBus } from '../../utils/EventBus.js'
import Event from '../../utils/EventNames.js';
import CommunityEventNames from '../EventNames.js'

export default function MediumArticleList(props = {}) {

  const {
    layout,
    articles: providedArticles,
    maxWidth = '100%',
    editable,
    news,
    featured,
    ouCorner,
    highlighted,
    ouCornerCategory,
    published
  } = props

  const [articles, setArticles] = useState([])

  const initialize = useCallback(async () => {
    if (providedArticles) {
      setArticles(providedArticles)
    }
  }, [providedArticles])

  useEffect(() => {
    EventBus.on(Event.REFRESH_PAGE, initialize)
    return () => {
      EventBus.removeListener(Event.REFRESH_PAGE, initialize)
    }
  }, [initialize])

  useEffect(() => {
    initialize()
  }, [initialize])

  const addArticle = () => {
    EventBus.emit(CommunityEventNames.OPEN_ADD_EDIT_ARITCLE_DIALOG, {
      mode: 'add',
      article: {
        featured,
        news,
        ouCorner,
        highlighted,
        ouCornerCategory,
        isDraft: !published
      },
      visibility: {
        featured,
        news,
        ouCorner,
        highlighted,
        ouCornerCategory,
      }
    })
  }

  const containerClass = editable ? "medium-articles-container article-section" : "medium-articles-container"
  return (<>
    <Box
      className={containerClass}>

      <Grid container gap={0} sx={{ position: 'relative' }} className="fit-height">
        {editable && published && <Grid item xs={12} className="add-icon">
          <div className="article-controls-backdrop">
            <IconButton size='medium' className="icon-button" onClick={addArticle}>
              <Add />
            </IconButton>
          </div>
        </Grid>}

        <Grid item xs={12} sx={{ minHeight: '200px' }} className="fit-height article-tile">
          <Grid container gap={0} className="fit-height">
            {!articles?.length && <span>No Articles</span>}
            {articles.map((article, index) => (
              <Grid item sm={12} md={6} lg={4} padding='4px' height='200px' key={article?.guid || article?.id || `article_${index}`}>
                <ArticleCard
                  editable={editable}                  
                  article={article}
                  published={published}
                  visibility={{
                    news,
                    featured,
                    ouCorner,
                    highlighted,
                    ouCornerCategory,
                  }}
                />
              </Grid>

            ))}
          </Grid>
        </Grid>
      </Grid>


    </Box>
  </>);
}
